import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { ProfiDesktopLayout, ProfiItem, ProfiMobileLayout } from '../../../components/Profi';
import { getProfiItemsConstants } from './constants';
import { QualityCriteriaModal } from '../../../components/QualityCriteriaModal';

export const ProfiContainer: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const PROFI_ITEMS_CONSTANTS = getProfiItemsConstants(isDesktop);

  const handleOpen = React.useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  if (isDesktop) {
    return (
      <>
        <ProfiDesktopLayout onClick={handleOpen}>
          {PROFI_ITEMS_CONSTANTS.map((item, index) => (
            <ProfiItem key={'ProfiItem' + index} {...item} />
          ))}
        </ProfiDesktopLayout>
        <QualityCriteriaModal handleClose={handleClose} isOpen={isOpen} />
      </>
    );
  }

  return (
    <>
      <ProfiMobileLayout onClick={handleOpen}>
        {PROFI_ITEMS_CONSTANTS.map((item, index) => (
          <ProfiItem key={'ProfiItem' + index} {...item} />
        ))}
      </ProfiMobileLayout>
      <QualityCriteriaModal handleClose={handleClose} isOpen={isOpen} />
    </>
  );
};
